(function(){
    'use strict';
    angular.module('Filters').filter('bbaCurrency', bbaCurrency);

    bbaCurrency.$inject = ['$filter', '$rootScope'];


    function bbaCurrency($filter, $rootScope) {
        return function(num, cur) {
            const office = $rootScope.GlobalProfile && $rootScope.GlobalProfile.office || {};
            const currency = cur || office.currency || 'AUD';
            return $filter('currency')(num, '') + ' ' + currency;
        }; 
    }
})();


// WEBPACK FOOTER //
// ./js/filters/bbaCurrency.js